import { make } from 'vuex-pathify';
import { DelinquencyActionsTaskAssignmentService } from '@/modules/global-settings/delinquency/services/delinquency-actions-task-assignment.service';
import Logger from '@/lib/logger.js';

const service = new DelinquencyActionsTaskAssignmentService();

export const state = {
  taskAssignments: []
};

export const mutations = {
  ...make.mutations(state)
};

export const getters = {
  ...make.getters(state)
};

export const actions = {
  /**
   * Retrieve the list of task assignments
   */
  async getAssignments({ commit }) {
    try {
      const { data } = await service.getAssignments();
      commit('SET_TASK_ASSIGNMENTS', data);
      return data;
    } catch (error) {
      Logger.error('Getting Delinquency Actions Task Assignments');
      throw error;
    }
  },

  async getPaginatedAssignments(_, params) {
    try {
      const { status, data } = await service.getPaginatedAssignments(params);
      if (status === 200) {
        return data; 
      }
      Logger.warn(`Non-200 status received: ${status}`);
      return { data: [], total: 0 };
    } catch (error) {
      Logger.error('Getting Paginated Delinquency Actions Task Assignments', error);
      return { data: [], total: 0 };
    }
  },

  /**
   * Updates the assignment by ID
   */
   async updateAssignment({ dispatch }, { id, payload }) {
    try {
      const { data } = await service.updateAssignment(id, payload);
      dispatch('getAssignments'); 
      return data;
    } catch (error) {
      Logger.error('Updating Delinquency Actions Task Assignment', error);
      throw error;
    }
  }
};
